import { render, staticRenderFns } from "./OfferStreamItem.vue?vue&type=template&id=483dfd60&scoped=true"
import script from "./OfferStreamItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferStreamItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./OfferStreamItem.vue?vue&type=style&index=0&id=483dfd60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483dfd60",
  null
  
)

export default component.exports